import { useEffect, useState } from 'react';
import { generateBooleanQuery, IBooleanQueryBuilderDTO, IJob } from 'wisestep-api';

const useGetSocialSearchBooleanString = (job: IJob) => {
  const [socialSearchBooleanString, setSocialSearchBooleanString] = useState<string>('');

  useEffect(() => {
    const getGeneratedBooleanQuery = async () => {
      const query: IBooleanQueryBuilderDTO = {
        mode: 'quick',
        jobTitle: job.title,
        requiredSkills: job.skills,
        jobDescription: job.description,
        jobId: job.id,
        queryTypes: { open: false, focused: true, comprehensive: false },
        queryResponse: { open: 'false', focused: 'true', comprehensive: 'false' },
      };
      try {
        const queryResponse = await generateBooleanQuery(query);

        setSocialSearchBooleanString(queryResponse.data.booleanQuery.focused);
      } catch (e) {
        console.error('Error occurred while generating the Boolean String', e);
        setSocialSearchBooleanString('');
      }
    };
    job && getGeneratedBooleanQuery();
  }, [job]);

  return { socialSearchBooleanString };
};

export default useGetSocialSearchBooleanString;
